/**
 * Scroll to and focus the first field in error after React has re-rendered.
 * Works with our .glass-input.error / .glass-textarea.error / select.error pattern.
 */
export function scrollToFirstError(container: HTMLElement | null = document.documentElement) {
  requestAnimationFrame(() => {
    const el = (container ?? document).querySelector<HTMLElement>(
      '.glass-input.error, .glass-textarea.error, select.error, [data-error="true"]',
    )
    if (!el) return
    el.scrollIntoView({ behavior: 'smooth', block: 'center' })
    setTimeout(() => el.focus({ preventScroll: true }), 250)
  })
}
